var React = require('react');

function Falcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("filter",{"x":"-3.5%","y":"-4.5%","width":"107.0%","height":"114.2%","filterUnits":"objectBoundingBox","id":"filter-1"},React.createElement("feGaussianBlur",{"stdDeviation":"0","in":"SourceGraphic"}))),React.createElement("g",{"id":"falcon-2","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("polygon",{"id":"Path","stroke":"#FFFFFF","strokeWidth":"3","filter":"url(#filter-1)","points":"25 31 3 59 9 21 23 7 31 11 37 3 43 11 51 7 65 21 71 59 49 31 43 35 49 49 37 44 25 49 31 35"}))]);
}

Falcon.defaultProps = {"viewBox":"0 0 74 65","version":"1.1"};

module.exports = Falcon;

Falcon.default = Falcon;
